<template>
  <Teleport to="body">
    <Transition name="sw-modal">
      <div
        v-if="visible"
        ref="modalRoot"
        class="sw-warning-modal sw-warning-modal--glass"
        role="presentation"
        tabindex="-1"
        @click.self="$emit('cancel')"
        @keydown.esc.prevent="$emit('cancel')"
      >
        <div
          class="sw-modal-content sw-modal-content--glass"
          role="alertdialog"
          aria-modal="true"
          aria-labelledby="sw-setup-warning-title"
          aria-describedby="sw-setup-warning-desc"
          @click.stop
        >
        <div class="sw-modal-body">
          <div class="sw-warning-icon-wrap">
            <span class="sw-warning-icon-ring" aria-hidden="true" />
            <span class="sw-warning-icon" aria-hidden="true">
              <i class="bi bi-exclamation-triangle-fill" />
            </span>
          </div>
          <h2 id="sw-setup-warning-title" class="sw-modal-title">Cancel setup?</h2>
          <p id="sw-setup-warning-desc" class="sw-modal-message">
            If you cancel this setup none of your information will be saved. Setup will continue on your next log in.
            Are you sure you want to cancel setup?
          </p>
        </div>
        <div class="sw-modal-footer">
          <SecondaryButton
            label="Yes"
            icon="bi bi-check-lg"
            custom-class="sw-modal-btn sw-modal-btn--confirm"
            @click="$emit('confirm')"
          />
          <PrimaryButton
            label="No"
            icon="bi bi-x-lg"
            custom-class="sw-modal-btn sw-modal-btn--dismiss"
            @click="$emit('cancel')"
          />
        </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import './SetupWaring.css';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';

export default {
  name: 'SetupWaring',
  components: {
    PrimaryButton,
    SecondaryButton,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['confirm', 'cancel'],
  watch: {
    visible(isOpen) {
      if (typeof document === 'undefined') return;
      document.body.style.overflow = isOpen ? 'hidden' : '';
      if (isOpen) {
        this.$nextTick(() => this.$refs.modalRoot?.focus?.());
      }
    },
  },
  beforeUnmount() {
    if (typeof document !== 'undefined') {
      document.body.style.overflow = '';
    }
  },
};
</script>
